import React, { useEffect, useRef } from 'react';

/**
 * The hero's right-hand composition: three stacked tiles that parallax a few
 * degrees towards the pointer, with a rotating badge behind them.
 *
 * Transform-only, so it costs one composited layer per tile and nothing at
 * all when the visitor has asked for reduced motion.
 */
function HeroTiles() {
  const stageRef = useRef(null);

  useEffect(() => {
    const stage = stageRef.current;
    if (!stage) return undefined;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return undefined;
    }

    const tiles = Array.from(stage.querySelectorAll('[data-depth]'));
    let raf = 0;
    let targetX = 0;
    let targetY = 0;
    let x = 0;
    let y = 0;

    const apply = () => {
      x += (targetX - x) * 0.08;
      y += (targetY - y) * 0.08;
      tiles.forEach((tile) => {
        const depth = Number(tile.dataset.depth);
        tile.style.transform =
          `translate3d(${x * depth * 26}px, ${y * depth * 26}px, 0)` +
          ` rotate(${tile.dataset.rotate || 0}deg)` +
          ` rotateX(${-y * depth * 8}deg) rotateY(${x * depth * 8}deg)`;
      });
      raf = requestAnimationFrame(apply);
    };

    const onMove = (event) => {
      const rect = stage.getBoundingClientRect();
      targetX = (event.clientX - (rect.left + rect.width / 2)) / rect.width;
      targetY = (event.clientY - (rect.top + rect.height / 2)) / rect.height;
    };

    window.addEventListener('pointermove', onMove, { passive: true });
    raf = requestAnimationFrame(apply);

    return () => {
      window.removeEventListener('pointermove', onMove);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div className="tiles" ref={stageRef} aria-hidden="true">
      <div className="badge">
        <svg viewBox="0 0 200 200">
          <defs>
            <path
              id="badge-path"
              d="M100,100 m-72,0 a72,72 0 1,1 144,0 a72,72 0 1,1 -144,0"
            />
          </defs>
          <text>
            <textPath href="#badge-path">
              BUILD · SHIP · SUPPORT · BUILD · SHIP · SUPPORT ·
            </textPath>
          </text>
        </svg>
      </div>

      <div className="tile tile-icon" data-depth="1.3" data-rotate="-6">
        <img src="/icon.png" alt="" width="104" height="104" />
      </div>

      <div className="tile tile-ui" data-depth="0.8" data-rotate="4">
        <span className="bar" />
        <span className="row">
          <i />
          <i className="wide" />
        </span>
        <span className="row">
          <i className="wide" />
          <i />
        </span>
        <span className="pillbtn">Ship it</span>
      </div>

      <div className="tile tile-stat" data-depth="1.6" data-rotate="-3">
        <strong>30 days</strong>
        <span>deletion window, every app</span>
      </div>
    </div>
  );
}

export default HeroTiles;
